import axios from "axios";
import {showToast, showLoadingToast, closeToast, showFailToast} from "vant";
import ycpSignature from "./ycp-signature";

// ---------- Token 管理 ----------
const TokenService = {
    getJwt() {
        return localStorage.getItem("jwt");
    },
    setJwt(token) {
        localStorage.setItem("jwt", token);
    },
    getRefreshToken() {
        return localStorage.getItem("refreshToken");
    },
    setRefreshToken(token) {
        localStorage.setItem("refreshToken", token);
    },
    getJwtExpiredAt() {
        return localStorage.getItem("jwtExpiredAt");
    },
    setJwtExpiredAt(time) {
        localStorage.setItem("jwtExpiredAt", time);
    },
    clear() {
        localStorage.removeItem("jwt");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("jwtExpiredAt");
    },
};

// 创建axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "/staging-api",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },

  // 自定义参数序列化，确保GET请求参数被正确编码
  paramsSerializer: {
    encode: (value) => {
      // 对参数值进行URL编码
      return encodeURIComponent(value);
    },
    serialize: (params) => {
      const parts = [];

      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value === null || typeof value === "undefined") {
          return;
        }

        let values = [];
        if (Array.isArray(value)) {
          values = value;
          key = key + "[]";
        } else {
          values = [value];
        }

        values.forEach((val) => {
          if (val instanceof Date) {
            val = val.toISOString();
          } else if (typeof val === "object") {
            val = JSON.stringify(val);
          }

          // 使用自定义的encode函数进行URL编码
          const encodedKey = encodeURIComponent(key);
          const encodedValue = encodeURIComponent(val);
          parts.push(`${encodedKey}=${encodedValue}`);
        });
      });

      return parts.join("&");
    },
  },
});
// ---------- 专门用于刷新 token 的实例（无拦截器）----------
const refreshAxios = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || "/api",
    timeout: 10000,
    headers: { "Content-Type": "application/json;charset=UTF-8" },
});
// ---------- 刷新状态控制 ----------
let isRefreshing = false;
let requestsQueue = [];
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示loading
    if (config.method !== "get" || config.showLoading) {
      // showLoadingToast({
      //   message: "加载中...",
      //   forbidClick: true,
      // });
    }

    // 生成羊城派API签名请求头
    const signatureHeaders = ycpSignature.generateHeaders(config);

    // 合并请求头
    config.headers = {
      ...config.headers,
      ...signatureHeaders,
    };
      // 添加 JWT（排除刷新接口，避免死循环）
      const token = TokenService.getJwt();
      console.log("token",token);
      if (token && !config.url.includes("/refreshToken")) {
          config.headers["Authorization"] = 'Bearer'+token;
      }
    // 记录请求信息（开发环境）
    if (import.meta.env.MODE === "development") {
      console.log("API请求:", {
        url: config.url,
        method: config.method,
        baseURL: config.baseURL,
        headers: config.headers,
        params: config.params,
        data: config.data,
      });
    }

    return config;
  },
  (error) => {
    closeToast();
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    closeToast();

    const res = response.data;
    // 根据业务状态码处理
    if (res.code == 200 || res.code == 0 || res.success == true) {
        // const {
        //     jwt: jwt,
        //     refreshToken: refreshToken,
        //     jwtExpiredAt,
        // } = res.data;
        // TokenService.setJwt(jwt);
        // console.log(TokenService.getJwt())
        // TokenService.setJwtExpiredAt(jwtExpiredAt);
        // console.log(jwtExpiredAt)
        // TokenService.setRefreshToken(refreshToken);
      return res;
    } else {
      const errorMsg = res.message || "请求失败";
      showToast(errorMsg);
      return Promise.reject(new Error(errorMsg));
    }
  },
  async (error) => {
      closeToast();
      const { config, response } = error;
      if (!response || !config) {
          return Promise.reject(error);
      }

      // ---------- 处理 1401 登录凭证失效 ----------
      if (response.data?.code == 1401) {
          // 如果已经是刷新请求失败，直接清空并跳转登录
          if (config.url.includes("/refreshToken")) {
              TokenService.clear();
              try {
                  const router = await import("@/router").then(
                      (module) => module.default,
                  );
                  router.push("/login");
              } catch (e) {
                  console.error("路由导入失败", e);
              }
              showToast("登录已过期，请重新登录");
              return Promise.reject(error);
          }

          // 如果正在刷新，将请求加入队列
          if (isRefreshing) {
              return new Promise((resolve) => {
                  requestsQueue.push({ resolve, config });
              });
          }

          isRefreshing = true;

          try {
              const refreshToken = TokenService.getRefreshToken();
              if (!refreshToken) throw new Error("No refresh token");

              // 调用刷新接口
              const refreshRes = await refreshAxios.post("/v1/user/refreshToken", {
                  refreshToken,
              });
              const res = refreshRes.data;

              if (res.code == 200) {
                  const {
                      jwt: jwt,
                      refreshToken: refreshToken,
                      jwtExpiredAt,
                  } = res.data;
                  TokenService.setJwt(jwt);
                  TokenService.setRefreshToken(refreshToken);
                  TokenService.setJwtExpiredAt(jwtExpiredAt);
                  console.log((TokenService.getJwt()))

                  // 重试当前请求
                  config.headers["Authorization"] = jwt;
                  const retryResult = await service(config);

                  // 重试队列中的请求
                  requestsQueue.forEach(({ resolve, config: oldConfig }) => {
                      oldConfig.headers["Authorization"] = jwt;
                      resolve(service(oldConfig));
                  });
                  requestsQueue = [];

                  return retryResult;
              } else {
                  throw new Error(res.message || "Refresh failed");
              }
          } catch (refreshError) {
              TokenService.clear();
              try {
                  const router = await import("@/router").then(
                      (module) => module.default,
                  );
                  router.push("/login");
              } catch (e) {
                  console.error("路由导入失败", e);
              }
              showToast("登录已过期，请重新登录");
              return Promise.reject(refreshError);
          } finally {
              isRefreshing = false;
          }
      }
      if(response.data?.code === '2400'){
          try {
              const router = await import("@/router").then(
                  (module) => module.default,
              );
              console.log("router",router)
              localStorage.removeItem('jwt')
              localStorage.removeItem('jwtExpiredAt')
              router.replace("/login");
          } catch (e) {
              console.error("路由导入失败", e);
          }
      }
      if(response.data?.code === '2100'){
         showToast(response.data?.message)
          return
      }
      // ---------- 其他错误处理（保持不变）----------
    let message = "网络错误";
    if (error.response) {
      switch (error.response.status) {
        case 400:
          message = "请求参数错误";
          break;
        case 401:
          message = "未授权";
          break;
        case 403:
          message = "签名验证失败";
          // 输出详细的签名错误信息
          if (import.meta.env.MODE === "development") {
            console.error("签名验证失败详情:", {
              requestHeaders: error.config?.headers,
              responseData: error.response?.data,
              requestUrl: error.config?.url,
              requestMethod: error.config?.method,
            });
          }
          break;
        case 404:
          message = "接口不存在";
          break;
        case 500:
          message = "服务器内部错误";
          break;
        case 502:
          message = "网关错误";
          break;
        case 503:
          message = "服务不可用";
          break;
        default:
          message = `请求错误: ${error.response.status}`;
      }

      // 如果是签名错误，显示详细错误信息
      if (error.response.status === 403) {
        const errorData = error.response.data;
        if (errorData && errorData.message) {
          message = errorData.message;
        }
      }
    } else if (error.code === "ECONNABORTED") {
      message = "请求超时";
    } else if (error.message === "Network Error") {
      message = "网络连接失败";
    }

    showToast(message);
    return Promise.reject(error);
  }
);

// 封装请求方法
const request = {
  // GET请求
  get(url, params = {}, config = {}) {
    // 注意：这里传入原始参数值，axios的paramsSerializer会自动进行URL编码
    return service.get(url, {
      params,
      ...config,
    });
  },

  // POST请求
  post(url, data = {}, config = {}) {
    return service.post(url, data, config);
  },

  // PUT请求
  put(url, data = {}, config = {}) {
    return service.put(url, data, config);
  },

  // DELETE请求
  delete(url, params = {}, config = {}) {
    return service.delete(url, { params, ...config });
  },

  // 文件上传
  upload(url, file, data = {}, config = {}) {
    const formData = new FormData();
    formData.append("file", file);

    // 添加其他参数
    if (data) {
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
      });
    }

    return service.post(url, formData, {
      ...config,
      headers: {
        "Content-Type": "multipart/form-data",
        ...config.headers,
      },
    });
  },

  // 获取签名工具（用于调试）
  getSignatureTool() {
    return ycpSignature;
  },

  // 构建请求URL（带编码）
  buildRequestUrl(path, params = {}) {
    const baseURL = import.meta.env.VITE_API_BASE_URL || "/api";
    return ycpSignature.buildFullUrlForRequest(baseURL, path, params);
  },

  // 构建签名URL（不带编码）
  buildSignatureUrl(path, params = {}) {
    const baseURL = import.meta.env.VITE_API_BASE_URL || "/api";
    return ycpSignature.buildFullUrlForSignature(baseURL, path, params);
  },
};

export default request;
